import React from "react";
import { motion } from "framer-motion";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import WellnessTip from "./health-tools/WellnessTip";
import HydrationCalculator from "./health-tools/HydrationCalculator";
import MoodCheckIn from "./health-tools/MoodCheckIn";
import PomodoroTimer from "./health-tools/PomodoroTimer";
import PostureReset from "./health-tools/PostureReset";
import MusicPlayer from "./health-tools/MusicPlayer";

const HealthTools: React.FC = () => {
  return (
    <section id="tools" className="py-20 bg-secondary/30">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Wellness Tools
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Simple, effective tools to help you relax, focus, and stay healthy
            throughout your day.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {/* 1. Music Player */}
          <div className="md:col-span-2 lg:col-span-2">
            <MusicPlayer />
          </div>

          {/* 2. Wellness Tip */}
          <WellnessTip />

          {/* 3. Pomodoro Timer */}
          <PomodoroTimer />

          {/* 4. Posture Reset */}
          <PostureReset />

          {/* 5. Mood Check-in */}
          <MoodCheckIn />

          {/* 6. Hydration Calculator */}
          <HydrationCalculator />
        </div>
      </div>
    </section>
  );
};

export default HealthTools;
